import React from 'react';
import GeneralEditWizzardBase from './GeneralEditWizzardBaseFigma';
import GeneralEditWizzardPageSideBySide from './GeneralEditWizzardPageSideBySideFigma';

/**
 * Side-by-side ("compare") wizard: `GeneralEditWizzardBaseFigma` with each step rendered as two panels —
 * read-only `readOnlyItem` on the left, the editable form on the right. Built for "review imported values
 * before saving" (CD-5406, Import from Contract). This class only owns the extra dataset; layout lives in
 * `GeneralEditWizzardPageSideBySideFigma`.
 *
 * Extra prop:
 *   readOnlyItem — dataset for the read-only panel; need not match the edited item. Defaults to a shallow
 *                  copy of it, so the panels start identical without sharing a reference.
 */
class GeneralEditWizzardBaseSideBySide extends GeneralEditWizzardBase {
  static defaultProps = {
    ...GeneralEditWizzardBase.defaultProps,
    errorCode: 'GEWBSBSF29',
    readOnlyItem: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      readOnlyItem: this.buildReadOnlyItem(props),
    };
  }

  // Copied either way: the caller's object must not be mutated, and the fallback must stay independent of
  // the edited item so the left panel keeps showing the original values.
  buildReadOnlyItem(props) {
    return props.readOnlyItem ? { ...props.readOnlyItem } : { ...this.state.editedItem };
  }

  // The dataset can arrive after mount (an extraction call resolving while the wizard is open), so re-seed
  // it when the caller hands over a different object.
  componentDidUpdate(prevProps) {
    if (prevProps.readOnlyItem !== this.props.readOnlyItem && this.props.readOnlyItem) {
      this.setState({ readOnlyItem: { ...this.props.readOnlyItem } });
    }
  }

  render() {
    return (
      <div>
        <GeneralEditWizzardPageSideBySide
          errorCode={this.props.errorCode}
          step={this.state.step}
          crudType={this.props.crudType}
          windowDescription={this.props.windowDescription}
          clickOnCancel={this.props.clickOnCancel}
          clickOnSave={this.clickOnSaveInWizzardPage}
          clickOnDelete={this.clickOnDeleteInWizzardPage}
          editedItem={this.state.editedItem}
          readOnlyItem={this.state.readOnlyItem}
          visitedSteps={this.state.visitedSteps}
          onChangeEditedItem={this.props.onChangeEditedItem}
        />
      </div>
    );
  }
}

export default GeneralEditWizzardBaseSideBySide;
